import React from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { TOUR_LANGUAGE_MENU } from '../contextMenuActions'
import ContextMenu from './ContextMenu'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { changeLanguage } from 'aria-viewer/language/languageActions'
import Browser from 'aria-viewer/utils/mobileDetect'
import { MAIN_TOUR_LANGUAGE_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const TourLanguageContextMenu = props => {
    const { languages, selectedLanguage, changeLanguage } = props
    return (
        <ContextMenu
            tabIndex={MAIN_TOUR_LANGUAGE_INDEX}
            name={TOUR_LANGUAGE_MENU}
            theme={!Browser.phone() ? styleguide.contextMenuDesktop.dark : styleguide.contextMenu.dark}
            allowScroll={!Browser.phone()}
            options={{
                list: languages.map(value => value.toObject()),
                title: 'Language',
                selected: selectedLanguage.toObject(),
                defaultAction: changeLanguage,
            }}
        />
    )
}

export default connect(
    mapSelectorsToProps(['selectedLanguage', 'languages']),
    {
        changeLanguage,
    }
)(TourLanguageContextMenu)
